import logout from "../utils/logout"

export function mountApiUrl(baseUrl, urlTemplate, values) {
  if (!urlTemplate) {
    throw Error("empty url template")
  }
  const urlPath = Object.keys(values).reduce((path, placeholder) => {
    const value = values[placeholder]
    if (path.indexOf(`<${placeholder}>`) < 0) {
      return path
    }
    if (!value) {
      throw Error(`fail on get attribute: ${placeholder}`)
    }
    return path.replace(`<${placeholder}>`, value)
  }, urlTemplate)
  if (urlPath.indexOf("<") >= 0) {
    throw Error(`fail on mount url by template. result=${urlPath}`)
  }
  return `${baseUrl}${urlPath}`
}

export function mountHeaders(user_id, token) {
  return {
    headers: {
      iduser: user_id,
      token: token,
    },
  }
}

export const handleNotAuthenticated = async (request) => {
  const result = await request()
  const status = result?.statusCode
  if (status === 403) {
    logout()
  }
  return result.data
}

export const handleLegacyResponse = async (request, getFirst = false) => {
  const data = await handleNotAuthenticated(request)
  if (!data?.SUCCESS) {
    return null
  }
  const result = data?.RESULT
  if (getFirst) {
    return result && result[0]
  }
  return result
}
